<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_STAKEHOLDER')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_STAKEHOLDER')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">
        <label>Stakeholder ({{getLengthOfFormArray('stakeholder')}})</label>

        <p *ngIf="getLengthOfFormArray('stakeholder') === 0">Keine Stakeholder definiert.</p>

        <table class="table table-striped table-sm mb-0" *ngIf="getLengthOfFormArray('stakeholder') > 0">
            <thead>
            <tr>
                <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th>Name</th>
                <th>Einfluss</th>
                <th>Interesse</th>
                <th>Erwartungen</th>
                <th>Maßnahmen</th>
            </tr>
            </thead>
            <tbody formArrayName="stakeholder">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'stakeholder').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry)"><i
                                class="fas fa-times"></i></button>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="name" *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.name }}</ng-container>
                    </td>
                    <td>
                        <select class="form-control" formControlName="influence" *ngIf="viewMode !== ViewMode.VIEW">
                            <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                            <option value="low">Gering</option>
                            <option value="medium">Mittel</option>
                            <option value="high">Groß</option>
                        </select>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.influence | influence }}</ng-container>
                    </td>
                    <td>
                        <select class="form-control" formControlName="interest" *ngIf="viewMode !== ViewMode.VIEW">
                            <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                            <option value="low">Gering</option>
                            <option value="medium">Mittel</option>
                            <option value="high">Groß</option>
                        </select>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.interest | interest }}</ng-container>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="expectations" *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.expectations }}</ng-container>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="measures" *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.measures }}</ng-container>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3" (click)="addFormItem({}, 'stakeholder')">
                <i class="fas fa-plus"></i> Stakeholder hinzufügen
            </button>

            <p>Stakeholder sind Personen, Personengruppen oder Organisationen, die von den Entscheidungen, Aktivitäten oder Resultaten eines Projekts betroffen sind oder ein damit verbundenes Interesse vertreten.</p>
        </div>
    </form>
</div>
